<template>
  <div class="market_coin">
    <div class="content_title">
      <div>{{ $t('交易对') }}</div>
      <div class="price">{{ $t('最新价') }}(CNY)</div>
      <div class="upDown">24H {{ $t('涨跌') }}</div>
      <div class="height">24H {{ $t('最高价') }}</div>
      <div class="low">24H {{ $t('最低价') }}</div>
      <div>24H {{ $t('成交量') }}</div>
    </div>
    <ul
      v-loading="loading"
      element-loading-background="rgba(255, 255, 255, 1)"
      class="content_content"
    >
      <li
        class="content_li"
        :class="{ contentLiBg: currentCoinName === item.symbol }"
        v-for="(item, index) in coinList"
        :key="index"
        @click="handleCoin(item)"
      >
        <p>
          <span
            @click.stop="
              isSignIn
                ? handleOriginCollect(item.symbol, dealCoinCollect(item.symbol))
                : handleNativeCollect(item.symbol)
            "
          >
            <img
              v-if="isSignIn"
              :src="
                dealCoinCollect(item.symbol)
                  ? collectionActive
                  : collectionNegative
              "
              alt=""
            />
            <img
              v-else
              :src="
                $store.state.market.collectCoinListLocal[item.symbol]
                  ? collectionActive
                  : collectionNegative
              "
              alt=""
            />
          </span>
          <span class="coin_name">{{
            item.symbol | coninNameFilter(isSelf)
          }}</span>
        </p>
        <p class="price">
          <span>{{ item.close }}</span>
          <span class="gray_text block_span">≈¥{{ item.valuation }}</span>
        </p>
        <p class="upDown">
          <span
            :class="{
              upGreen: Number(item.chg) > 0,
              downRed: Number(item.chg) < 0
            }"
            class="smoothGray"
            >{{ item.chg }}%</span
          >
        </p>
        <p class="height">
          <span>{{ item.high }}</span>
        </p>
        <p class="low">
          <span>{{ item.low }}</span>
        </p>
        <p>{{ item.volume }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
import collect from '@/mixin/collect'
import {
  SET_CURRENT_COIN_NAME,
  SET_CURRENT_COIN_INFO
} from '@/store/mutation-types'
export default {
  mixins: [collect],
  data() {
    return {
      collectionActive: require('./../../../assets/images/zixuan-xingxing-yixuan-blue.png'),
      collectionNegative: require('./../../../assets/images/zixuan-xingxing-weixuan.png')
    }
  },
  props: {
    isSelf: {
      // 是否是“自选” tab
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: true
    },
    coinList: {
      type: Array,
      required: true
    }
  },
  computed: {
    currentCoinName() {
      return this.$store.state.market.currentCoinName
    }
  },
  methods: {
    handleCoin(item) {
      this.$store.commit(`market/${SET_CURRENT_COIN_NAME}`, item.symbol)
    }
  },
  filters: {
    coninNameFilter(name, isSelf) {
      if (isSelf) {
        return name
      } else {
        const strIndex = name.indexOf('/')
        const result = name.substring(0, strIndex)
        return result
      }
    }
  }
}
</script>
<style lang="less" scoped>
.market_coin {
  .content_title {
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  }
  .content_title,
  .content_li {
    position: relative;
    padding: 12px 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(97, 104, 136, 1);
      line-height: 17px;
    }
  }
  .content_content {
    min-height: 400px;
    .content_li {
      padding: 7px 20px;
      height: 50px;
      cursor: pointer;
      p {
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        .gray_text {
          color: rgba(153, 153, 153, 1);
        }
        .block_span {
          display: block;
        }
      }
      // 动态改变字体颜色
      .smoothGray {
        color: rgba(153, 153, 153, 1);
      }
      .upGreen {
        color: rgba(65, 179, 126, 1);
      }
      .downRed {
        color: rgba(206, 68, 68, 1);
      }
    }
    .content_li:hover {
      background: rgba(248, 248, 248, 1);
    }
    .contentLiBg {
      background: rgba(248, 248, 248, 1);
    }
  }
  .coin_name {
    margin-left: 10px;
    font-size: 16px !important;
  }
  .price {
    display: flex;
    position: absolute;
    right: 70%;
    text-align: right;
  }
  .upDown {
    position: absolute;
    right: 53.15%;
  }
  .height {
    position: absolute;
    right: 35.48%;
    text-align: right;
  }
  .low {
    position: absolute;
    right: 17.81%;
    text-align: right;
  }
}
</style>
